<template>
    <div :class="['z-hero', heroClass]" v-if="!error">
        <div class="z-hero__content">
            <div class="container">
                <slot name="breadcrumbs" />
                <h1 class="z-hero__title" v-html="heroTitle"></h1>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'z-hero',
    props: {
        title: {
            type: String,
            default: ''
        },
        titleShow: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            pageHero: this.$root.app.page.hero,
            error: this.$root.app.page.error.state,
            animated: false
        }
    },
    created () {
        this.SetHeroTitle(this.title)

        if (this.pageHero) {
            if (this.pageHero.title && this.pageHero.title !== '') {
                this.SetHeroTitle(this.pageHero.title)
            }
        }
    },
    methods: {
        ...mapActions([
            'SetHeroTitle'
        ])
    },
    computed: {
        ...mapGetters([
            'heroTitle'
        ]),
        heroClass () {
            return [
                { 'z-hero--with-image': this.src }
            ]
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
